require('./chatNotification.tpl.html');
require('./chatNotificationController.js');
require('./chatNotificationModel.js');

const ChatNotificationComponent = {
    templateUrl: '/common/header/chatNotification/chatNotification.tpl.html',
    controller: 'chatController'
};

angular.module('ums')
    .component('uiChatNotification', ChatNotificationComponent);
